// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"2fe69470","453":"8e528733"}[chunkId] + ".chunk.js";
};